export const DATE_TIME_FORMAT = {
  year: "numeric",
  month: "long",
  day: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  timeZoneName: "short",
  hourCycle: "h24",
};

export const PAGE_HEADERS = {
  SORT: {
    tab: "overview.tabHeading",
    tabAlt: "Sort",
    head: "overview.heading",
    headAlt: "Overview",
    desc: "overview.description",
    descAlt:
      "This table provides an overview of the current sort process flow performance data",
  },
  OVERVIEW_V3: {
    head: "overviewv3.heading",
    headAlt: "Dashboard",
  },
  OUTBOUND: {
    tab: "outboundAMZL.tabHeading",
    tabAlt: "Outbound",
    head: "outboundAMZL.overviewHeading",
    headAlt: "Overview",
    desc: "outboundAMZL.overviewDescription",
    descAlt:
      "This table provides an overview of routes and their status in the outbound process",
  },
  OUTBOUND_ARV2: {
    tab: "outboundARV2.tabHeading",
    tabAlt: "Outbound",
    head: "outboundARV2.overviewHeading",
    headAlt: "Outbound Overview",
    desc: "outboundARV2.overviewDescription",
    descAlt: "Summary view of outbound routes by status and wave time",
  },
  LABS: {
    tab: "labs.tabHeading",
    tabAlt: "Labs",
    head: "labs.overviewHeading",
    headAlt: "Labs",
    desc: "labs.overviewDescription",
    descAlt: "",
  },
  SETTINGS: {
    tab: "setting.tabHeading",
    tabAlt: "Labs",
    head: "settings.overviewHeading",
    headAlt: "Settings",
    desc: "settings.overviewDescription",
    descAlt: "This page allows you to change labor settings",
  },
  ROUTE_STATUS: {
    tab: "outboundAMZL.tabHeading",
    tabAlt: "Outbound",
    head: "route.heading",
    headAlt: "Route Status",
    desc: "route.description",
    descAlt:
      "This table shows route's status and details during the outbound stage process",
  },
};

export const FEATURES = {
  IS_LMOCS_ENABLED_FOR_OPS_CLOCK_DATA: "isLMOCSEnabledForOpsClockData",
  IS_SHIFT_PLAN_ENABLED: "isShiftPlanEnabled",
  IS_DYNAMIC_SHIFT_PLAN_ENABLED: "isDynamicShiftPlanEnabled",
  IS_DYNAMIC_SHIFT_PLAN_ALERT_ENABLED: "isDynamicShiftPlanAlertEnabled",
  IS_SWA_REVERSE_CYCLE_ENABLED: "isSWAReverseCycleEnabled",
  IS_MY_SCC_ENABLED: "isMySCCEnabled",
};

export const SHIFT_PLANNING = {
  PLAN_STATUS: {
    APPROVED: "APPROVED",
    CLOSED: "CLOSED",
    FAILED: "FAILED",
    PENDING_APPROVAL: "PENDING_APPROVAL",
    PENDING_CREATION: "PENDING_CREATION",
    REJECTED: "REJECTED",
    CANCELLED: "CANCELLED",
  },
  PLAN_VERSIONS: {
    DYNAMIC_V1: "DYNAMIC_V1",
    DYNAMIC_V2: "DYNAMIC_V2",
    STATIC_V1: "STATIC_V1",
  },
  DYNAMIC_PLAN_NOTIFICATION_REFRESH: 60 * 1000,
  IFRAME_URL_PATH:
    ".utr-shift-plan-management-website.last-mile.amazon.dev/?stationCode=",
  IFRAME_CYCLES_URL_PATH: "&cycleId=AllCycles#/shiftplan",
};

export const PROCESS_ORDER = {
  TWILIGHT: 0,
  INDUCT: 1,
  STOW: 2,
  PICK: 3,
  DISPATCH: 4,
};

export const AMAZON_SUFFIX = "@amazon.com";
export const TIMEOUT_STRING = "timeout";

export const SCC_SETTINGS_MANAGER = ["Station Settings Manager"];
export const SCC_SETTINGS_MANAGER_STATION_LEVEL = [
  "Station Settings Manager",
  "Warehouse Manager",
];

export const ROOT_STATIONS = {
  NA: ["US_ROOT", "BR_ROOT", "MX_ROOT", "CA_ROOT"],
  EU: [
    "AE_ROOT",
    "AMZN_DE",
    "AMZN_ES",
    "AMZN_IT",
    "AMZN_FR",
    "AMZN_AT",
    "AMZN_UK",
    "AMZN_IE",
    "SA_ROOT",
    "EG_ROOT",
    "TR_ROOT",
    "BE_ROOT",
    "NL_ROOT",
  ],
  JP: ["JP_AMZL_ROOT", "AU_ROOT", "SG_ROOT"],
  IN: ["IN_ROOT"],
};

export const SETTINGSV2_PERMISSIONS_REGION = ["na", "eu", "jp"];

export const OPS_CLOCK_PROCESS = {
  TWILIGHT: "TWILIGHT",
  INDUCT: "INDUCT",
  STOW: "STOW",
  PICK: "PICK",
  DISPATCH: "DISPATCH",
};

export const USER_NOT_AUTHORIZED_EDIT = "User not authorized for overrides";

export const SETTINGS_PERMISSIONS_WARNING = {
  NA: "Beginning 6/8, station leaders will no longer be able to update SCC Settings. Please review this network communication for more details - https://tiny.amazon.com/h8rur2ev/starwwopamazdevboarbrow",
  EU: "Beginning 10/2, station leaders will no longer be able to update SCC Settings. Please raise a SIM via RIVER workflow via EU Central Operations - https://tiny.amazon.com/14d2pr4jf/riveamaz",
};

export const PROD = "prod";
export const MASTER = "master";
export const GAMMA = "gamma";
export const INTEG = "integ";

export const REGION = {
  EU: "eu",
  NA: "na",
  IN: "in",
  JP: "jp",
};

export const CONFIG_GROUP_TYPES = {
  DEFAULT: "DEFAULT",
  STATION_CODE: "STATION_CODE",
  USER_ALIAS: "USER_ALIAS",
  PRIORITY: "PRIORITY",
};

export const metricProcessName = "SCC_OVERVIEW";
export const DolphinVerificationProcessName = "SCC_DOLPHIN_VERIFICATION";
export const HTTP_SUCCESS_STATUS = 200;
export const AMXL_SHIPMENT_TYPES = {
  SCHEDULED_DELIVERY: "Scheduled Delivery",
  PDD: "PDD",
  MULTI_BOX: "Multi-box",
  PALLET: "Pallet",
};
export const AMXL_ROUTE_TYPES = {
  XL: "XL",
  CP: "CP",
};

export const TIMEOUTS = {
  RSWS_DEFAULT_API_TIMEOUT: 3000,
  RSWS_GET_STATION_ROUTES_API_TIMEOUT: 45000,
  NODE_CONFIG_REQUEST_TIMEOUT: 25000,
};

export const TIME_PATTERN = /^([01]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/;

export const TCP_ROLE = {
  WAREHOUSE_MANAGER: "AmazonFacility::Warehouse Manager",
  WAREHOUSE_ASSOCIATE: "AmazonFacility::Warehouse Associate",
};

export const ROUTE_VIEW = "ROUTE_VIEW";
export const DEFAULT_REFRESH_INTERVAL = 60 * 1000; // 1 minute.

export const DRIVER_TYPES = {
  DP: "DP",
  DSP: "DSP",
};

export const SECONDS_PER_MINUTE = 60;
export const DECIMAL_BASE = 10;
export const SLASH = "/";

export const PERCENTAGE = "%";

export const ROSTER_MANAGEMENT_ENABLED_COUNTRIES = [
  "MX",
  "BR",
  "AE",
  "SA",
  "EG",
];

export const OPSCLOCK_UPLOAD_ENABLED_COUNTRIES = ["MX", "BR", "AE", "SA", "EG"];



// WEBPACK FOOTER //
// ./src/components/util/Constants.js